import { gql } from '@apollo/client';

export const GET_CURRENT_USER = gql`
	query GetUserWithIdle ($startDate: DateTime, $endDate: DateTime, $prevStartDate: DateTime, $prevEndDate: DateTime) {
		currentUser{
			userID
			firstName
			lastName
			email
			isDriver
			isInDriverRole
			idleInfo(startDate: $startDate, endDate: $endDate) {
				summaryDate				
				idlePercentage				
    	}
			idleProjection {
				projectedIdlePercentage
				periodLength
				periodType
				dailyProjections {
					date
					actualIdlePercentage
					projectedIdlePercentage
				}
			}
			scorecard(startDate: $startDate, endDate: $endDate, prevStartDate: $prevStartDate, prevEndDate: $prevEndDate) {
				userID
				currentScore
				previousScore
				trend
				rank
				maxRank
				acknowledgment {
				  acknowledgmentID
				  acknowledged
				  acknowledgedByUserID
				  acknowledgedDate
				}
				incidentCount
				incidents {
				  incidentID
				  userID
				  name
				  details
				  severity
				  startTime
				  endTime
				  locationGroupID
				}
			}
		}
	}
`;

export const GET_ORGANIZATION = gql`
	query GetOrganizationWithGoals {
		organization {
			organizationID
			name
			viewableWindow
			startViewableWindow
			endViewableWindow
			previousStartViewableWindow
			previousEndViewableWindow
			goals {
				goalID
				organizationID
				goalTypeID
				goalTypeName
				name
				description
				targetValue
			}
		}
	}
`;

export const GET_USERS = gql`
	query GetUsers($groupID: Int, $onlyDrivers: Boolean = false, $userID: Int, $startDate: DateTime, $endDate: DateTime, $prevStartDate: DateTime, $prevEndDate: DateTime) {
	  users(groupID: $groupID, onlyDrivers: $onlyDrivers, userID: $userID) {
	    userID
	    firstName
	    lastName
	    email
	    isDriver
	    isInDriverRole
			scorecard(startDate: $startDate, endDate: $endDate, prevStartDate: $prevStartDate, prevEndDate: $prevEndDate) {
				userID
				currentScore
				previousScore
				trend
				rank
				maxRank
				acknowledgment {
				  acknowledgmentID
				  acknowledged
				  acknowledgedByUserID
				  acknowledgedDate
				}
			  incidentCount
			  incidents {
			    incidentID
			    incidentCategory
			    userID
			    name
			    details
			    severity
			    startTime
			    endTime
			    locationGroupID
			    scoringCriteriaScore
			  }
			}
	  }
	}
`;

export const GET_GROUPS = gql`
	query getGroups($groupID: Int, $isLocationGroup: Boolean, $hasDrivers: Boolean, $startDate: DateTime, $endDate: DateTime, $prevStartDate: DateTime, $prevEndDate: DateTime) {
	  groups(groupID: $groupID, isLocationGroup: $isLocationGroup, hasDrivers: $hasDrivers) {
	    groupID
	    name
	    description
	    parentGroupID
	    scorecard(startDate: $startDate, endDate: $endDate, prevStartDate: $prevStartDate, prevEndDate: $prevEndDate) {
	      locationGroupID
	      avgCurrentScore
	      avgPreviousScore
	      trend
	    }
	  }
	}
`;

export const GET_INCIDENTS = gql`
	query getIncidents($groupID: Int, $userID: Int) {
	  incidents(groupID: $groupID, userID: $userID) {
	    incidentID
	    incidentCategory
	    userID
	    name
	    details
	    severity
	    startTime
	    endTime
	    locationGroupID
	    scoringCriteriaScore
	  }
	}
`;

export const GET_MISSED_ACKNOWLEDGMENTS_REPORT = gql`
  query getMissingAcknowledgmentsReport($groupID: Int!, $startDate: DateTime, $endDate: DateTime) {
  	missingAcknowledgmentsReport(groupID: $groupID, startDate: $startDate, endDate: $endDate) {
	    acknowledgmentID
	    acknowledged
	    acknowledgedByUserID
	    acknowledgedDate
	    locationGroupID
	    endDate
	    startDate
	    deadline
	    user {
	      userID
	      firstName
	      lastName
	      email
	      isDriver
	      isInDriverRole
	    }
  	}
  }
`;

export const GET_MISSED_ACKNOWLEDGMENTS_CSV_REPORT = gql`
  query getMissedAcknowledgmentsCsvReport($groupID: Int, $startDate: DateTime, $endDate: DateTime) {
    missingAcknowledgmentsReport(groupID: $groupID, startDate: $startDate, endDate: $endDate) {
      acknowledgmentID
      acknowledged
      acknowledgedDate
      locationGroupID
      locationGroupName
      startDate
      endDate
      user {
        userID
        firstName
        lastName
      }
    }
  }
`;

export type AcknowledgmentInputType = {acknowledgment: { acknowledgmentID: number}}

export const ACKNOWLEDGE_SCORECARD = gql`
	mutation acknowledgeScorecard($acknowledgment: AcknowledgmentInputType!, $clear: Boolean) {
	  ack(acknowledgment: $acknowledgment, clear: $clear) {
	    acknowledgmentID
	    acknowledged
	    acknowledgedByUserID
	    deadline
	    acknowledgedDate
	  }
	}
`;
